import type { PurchaseConfirmationDetails } from '../../global-types/Content';
import Paragraph from '../paragraph/Paragraph';

function PurchaseConfirmationCard({ details }: { details: PurchaseConfirmationDetails }) {
  return (
    <div className="if card elevated mb-8 size-w-100p">
      <div className="if card-content flex-column gap-4">
        <Paragraph text={details.purchaseText} size="small" color="color-brown-700" />
        <Paragraph text={details.productName} size="large" />
        <Paragraph text={details.startDateText} size="small" color="color-brown-700" />
        <Paragraph text={details.startDateValue} size="large" />
      </div>
    </div>
  );
}

export default PurchaseConfirmationCard;
